angular.module("digitalLeasing.module").component("insurance", {
  templateUrl: "ng/components/digitalLeasing/financialData/insurance/insurance.view.html",
  bindings: {
    model: "=",
    onInsuranceChanges: "&",
    checkComponent: "&",
    callRestInsurance: "<",
    snapshot: '<',
    checkEstimatesInsuranceChanged: '&'
  },
  controllerAs: "InsuranceCtrl",
  controller: InsuranceController,
});

function InsuranceController(
  $financialApiService,
  $scope,
  $rootScope,
  $configService
) {
  var self = this;
  self.$rootScope = $rootScope;
  self.$onInit = function () {
    self.checkPreventivLevel2 = $configService.getAppConfig().allFunctionalities.includes("PREVENTIVO_LEVEL2");
    self.checkPreventivLevel3 = $configService.getAppConfig().allFunctionalities.includes("PREVENTIVO_LEVEL3");
    self.checkFunctionality = self.checkPreventivLevel2 || self.checkPreventivLevel3,
      self.checkValidityImporto = [];
    self.checkValidityPermillari = [];
    self.supportModel = {
      insurance: [],
      polizze: [],
      selected: [],
      checkError: [],
      visualError: [],
      enableErrorPerm: [],
      errorPermissionInsurance: []
    };
    if (self.model.leasingData.preventivo.assicurazioni.length > 0) {
      self.resume = true;
    }
    getAssicurazioni(self.resume);
    checkPage();
  };

  self.$onChanges = function (changed) {
    if (
      changed.callRestInsurance &&
      typeof changed.callRestInsurance.currentValue != "undefined"
    ) {
      getAssicurazioni();
    }
  };

  self.handleInsuranceChange = function (property, value, index, internalCall) {
    if (property == "issuranceType") {
      self.supportModel.errorPermissionInsurance[index] = false;
      var tempInsuranceSelected = [].concat(self.model.leasingData.preventivo.assicurazioni);
      tempInsuranceSelected.splice(index, 1);
      var test = tempInsuranceSelected.some(function (element) {
        return element.id == value.id;
      })
      if (test) {

        self.model.leasingData.preventivo.assicurazioni[index] = "";
      }
      value.selected = true;
      deselectOldValue(index);
      self.checkAssicurazioni(value.tipoServizio, index);
      var permillare = {
        value: value.polizze[0].premi.permPremioAttivo
      }
      self.handleInsuranceChange('permillari', permillare, index)
      self.checkEstimatesInsuranceChanged();
    } else if (property == "policyType") {

      self.model.leasingData.preventivo.assicurazioni[index].polizze[0] = value;

    } else if (property == "importo") {

      self.model.leasingData.preventivo.assicurazioni[
        index
      ].polizze[0].premi.permPremioAttivo =
        Math.round(
          ((value.value * 1000) / self.model.leasingData.preventivo.assicurazioni[index].importoPolizzaCalcolato) *
          1000
        ) / 1000;
      if (
        self.model.leasingData.preventivo.assicurazioni[index].premioDigitato
      ) { } else if (
        self.model.leasingData.preventivo.assicurazioni[index].polizze[0].premi
          .permPremioAttivo >
        self.model.leasingData.preventivo.assicurazioni[index].polizze[0]
          .premi.validations.permPremioAttivo.massimo.valore ||
        self.model.leasingData.preventivo.assicurazioni[index].polizze[0].premi
          .permPremioAttivo <
        self.model.leasingData.preventivo.assicurazioni[index].polizze[0]
          .premi.validations.permPremioAttivo.minimo.valore ||
        typeof value.value == "undefined"
      ) {
        self.supportModel.enableErrorPerm[index] = true;
        $scope.formInsurance && $scope.formInsurance["insurance-premium-" + index] &&
          $scope.formInsurance["insurance-premium-" + index].$setValidity(
            "insurance-premium-" + index,
            false
          );
        $scope.formInsurance && $scope.formInsurance["insuranceCurrency-" + index] &&
          $scope.formInsurance["insuranceCurrency-" + index].$setValidity(
            "insuranceCurrency-" + index,
            false
          );
        jQuery("#insurance-premium-percentage-" + index).addClass("has-error");
        jQuery("#insurance-currency-" + index).addClass("has-error");
        self.checkValidityPermillari[index] = false;
      } else {
        self.supportModel.enableErrorPerm[index] = false;
        $scope.formInsurance && $scope.formInsurance["insurance-premium-" + index] &&
          $scope.formInsurance["insurance-premium-" + index].$setValidity(
            "insurance-premium-" + index,
            true
          );
        $scope.formInsurance && $scope.formInsurance["insuranceCurrency-" + index] &&
          $scope.formInsurance["insuranceCurrency-" + index].$setValidity(
            "insuranceCurrency-" + index,
            true
          );
        jQuery("#insurance-premium-percentage-" + index).removeClass(
          "has-error"
        );
        jQuery("#insurance-currency-" + index).removeClass("has-error");
        self.checkValidityPermillari[index] = true;
      }
    } else if (property == "permillari") {
      if (
        self.model.leasingData.preventivo.assicurazioni[index].premioDigitato
      ) { } else if (self.model.leasingData.preventivo.assicurazioni[index].polizze[0].premi &&
        self.model.leasingData.preventivo.assicurazioni[index].polizze[0].premi.validations &&
        self.model.leasingData.preventivo.assicurazioni[index].polizze[0].premi.validations.permPremioAttivo &&
        self.model.leasingData.preventivo.assicurazioni[index].polizze[0].premi.validations.permPremioAttivo.massimo &&
        self.model.leasingData.preventivo.assicurazioni[index].polizze[0].premi.validations.permPremioAttivo.minimo &&
        (value.value >
          self.model.leasingData.preventivo.assicurazioni[index].polizze[0]
            .premi.validations.permPremioAttivo.massimo.valore ||
          value.value <
          self.model.leasingData.preventivo.assicurazioni[index].polizze[0]
            .premi.validations.permPremioAttivo.minimo.valore ||
          typeof value.value == "undefined")
      ) {
        self.supportModel.enableErrorPerm[index] = true;
        $scope.formInsurance && $scope.formInsurance["insurance-premium-" + index] &&
          $scope.formInsurance["insurance-premium-" + index].$setValidity(
            "insurance-premium-" + index,
            false
          );
        $scope.formInsurance && $scope.formInsurance["insuranceCurrency-" + index] &&
          $scope.formInsurance["insuranceCurrency-" + index].$setValidity(
            "insuranceCurrency-" + index,
            false
          );
        jQuery("#insurance-premium-percentage-" + index).addClass("has-error");
        jQuery("#insurance-currency-" + index).addClass("has-error");
        self.checkValidityImporto[index] = false;
      } else {
        self.supportModel.enableErrorPerm[index] = false;
        $scope.formInsurance && $scope.formInsurance["insurance-premium-" + index] &&
          $scope.formInsurance["insurance-premium-" + index].$setValidity(
            "insurance-premium-" + index,
            true
          );
        $scope.formInsurance && $scope.formInsurance["insuranceCurrency-" + index] &&
          $scope.formInsurance["insuranceCurrency-" + index].$setValidity(
            "insuranceCurrency-" + index,
            true
          );
        jQuery("#insurance-premium-percentage-" + index).removeClass(
          "has-error"
        );
        jQuery("#insurance-currency-" + index).removeClass("has-error");
        self.checkValidityImporto[index] = true;
      }
      self.model.leasingData.preventivo.assicurazioni[index].polizze[0].premi.importoPremioAttivo =
        Math.round(
          ((self.model.leasingData.preventivo.assicurazioni[index].importoPolizzaCalcolato * value.value) / 1000) *
          100
        ) / 100;
    }

    self.onInsuranceChanges({
      insurance: self.model,
    });

    checkPage();
  };

  var getAssicurazioni = function (fromResume) {
    if (self.snapshot) {
      return
    }
    $rootScope.$broadcast('componentLoader', {
      action: 'OPEN'
    });
    self.loaderInsurance = true;
    $financialApiService
      .getAssicurazioni(self.model)
      .then(function (response) {
        if (!!!response.assicurazioni.length) {
          self.showError = true;
        } else {
          self.showError = false;
        }
        self.model.financialVendor.dataISVAP = response.dataISVAP;
        self.model.financialVendor.numeroISVAP = response.numeroISVAP;
        self.responseAssicurazioni = response;
        self.supportModel.insurance = response.assicurazioni;
        if (!fromResume) {
          populateDefaultInsurance();
        } else {
          upgradeValueOfInsuranceSelected();
        }
        checkIfInsuranceIsPresent();
        if (self.model.leasingData.preventivo.assicurazioni && self.model.leasingData.preventivo.assicurazioni.length) {
          self.model.leasingData.preventivo.assicurazioni.forEach(function (element, index) {

            self.checkAssicurazioni(element.id, index);
          })
        }
        $rootScope.$broadcast('componentLoader', {
          action: 'CLOSE'
        });
        //comando inserito per sbloccare la ricerca sui listini presenti nel componente precedente
        $('#listino :input').prop("disabled", false);
        self.loaderInsurance = false;
        checkPage();

      })
      .catch(function (error) {
        console.log(error);
        $rootScope.$broadcast('componentLoader', {
          action: 'CLOSE'
        });
        //comando inserito per sbloccare la ricerca sui listini presenti nel componente precedente
        $('#listino :input').prop("disabled", false);
        self.loaderInsurance = false;
        checkPage();
      });
  };

  var populateDefaultInsurance = function () {
    if (!self.model.leasingData.preventivo.assicurazioni.length) {
      self.model.leasingData.preventivo.assicurazioni = self.supportModel.insurance.filter(
        function (elem) {
          return elem.selected == true;
        }
      );

    } else {
      self.model.leasingData.preventivo.assicurazioni.forEach(function (insuranceSelected, index) {
        var tempInsurance = self.supportModel.insurance.find(
          function (elem) {
            return elem.id == insuranceSelected.id;
          })
        if (tempInsurance && tempInsurance.id) {
          self.model.leasingData.preventivo.assicurazioni[index] = Object.assign(tempInsurance)
        } else {
          self.model.leasingData.preventivo.assicurazioni[index] = Object.assign(self.supportModel.insurance.find(
            function (elem) {
              return elem.selected == true;
            }
          ))
        }

      })
      self.model.leasingData.preventivo.assicurazioni.forEach(function (insuranceSelected, index) {
        self.supportModel.errorPermissionInsurance[index] = !self.supportModel.insurance.some(function (listInsurance) {
          return listInsurance.id == insuranceSelected.id;
        })
      })
      console.log(self.supportModel.errorPermissionInsurance)
    }


    if (self.model.leasingData.preventivo.assicurazioni.length == 0) {
      self.enableErrorNotInsurance = true;
    }
  };

  self.addNewInsurance = function () {
    self.model.leasingData.preventivo.assicurazioni.push("");
    self.enableErrorNotInsurance = false;
  };

  self.removeInsurance = function (index) {
    var assicurazione = self.model.leasingData.preventivo.assicurazioni.splice(
      index,
      1
    );
    deselectOldValue(index);
    self.supportModel.visualError[index] = null;
    checkIfInsuranceIsPresent();
    checkPage();
  };

  self.checkAssicurazioni = function (tipoServizio, index) {
    var codici = self.model.leasingData.preventivo.assicurazioni.map(function (
      e
    ) {
      return e.tipoServizio;
    }).filter(function (e) {
      return e != undefined
    });
    self.checkAssicurazioniIsRunning = true;
    checkPage();
    $financialApiService
      .checkAssicurazioni(codici, self.responseAssicurazioni)
      .then(function (response) {
        self.supportModel.checkError = response;
        var personsInsurance = response
          .find(function (element) {
            return element.codiceServizio == "---";
          })

        if (personsInsurance) {
          self.supportModel.visualError[0] = personsInsurance;
          return;
        } else {
          self.supportModel.visualError[0] = undefined;
        }

        if (typeof tipoServizio != "undefined" && typeof index != "undefined") {
          checkForEnableError(tipoServizio, index);
        }

        self.model.leasingData.preventivo.assicurazioni
          .forEach(function (element, index) {

            deselectOldValue(index);

          })
        self.checkAssicurazioniIsRunning = false;
        checkPage();
      })
      .catch(function (error) {
        console.log(error);
        self.checkAssicurazioniIsRunning = false;
        checkPage();
      });
  };

  var deselectOldValue = function (index) {
    var codInsuranceSelected = self.model.leasingData.preventivo.assicurazioni.map(
      function (x) {
        return x.id;
      }
    );

    self.supportModel.insurance.forEach(function (e) {
      if (index == 0) {
        if (e.id == codInsuranceSelected[0]) {
          e.selected = true;
        } else {
          e.selected = false;
        }
      } else if (index > 0 && index < 2) {
        if (
          e.id == codInsuranceSelected[0] ||
          e.id == codInsuranceSelected[1]
        ) {
          e.selected = true;
        } else {
          e.selected = false;
        }
      } else {
        if (
          e.id == codInsuranceSelected[0] ||
          e.id == codInsuranceSelected[1] ||
          e.id == codInsuranceSelected[2]
        ) {
          e.selected = true;
        } else {
          e.selected = false;
        }
      }
    });
  };

  var checkForEnableError = function (selected, index) {
    self.supportModel.visualError[index] = self.supportModel.checkError.find(
      function (element) {
        return element.codiceServizio == selected;
      }
    );
  };

  var checkPage = function () {
    var test = self.model.leasingData.preventivo.assicurazioni.every(function (
      element
    ) {
      return (
        element &&
        element.polizze &&
        element.polizze[0] &&
        element.polizze[0].premi &&
        typeof element.polizze[0].premi.permPremioAttivo != "undefinend" &&
        typeof element.polizze[0].premi.importoPremioAttivo != "undefinend"
      );
    });

    var testErrorAssicurazioni = self.supportModel.visualError.some(function (element) {
      return element != undefined
    })

    var checkValidity = self.supportModel.enableErrorPerm.every(function (e) {
      return e == false;
    });

    var checkInsurancePermission = self.supportModel.errorPermissionInsurance
      .every(function (element) {
        return element == false
      })

    if (test &&
      checkValidity &&
      checkInsuranceIsCompleted() &&
      !self.showError &&
      !self.loaderInsurance &&
      !self.checkAssicurazioniIsRunning &&
      checkInsurancePermission &&
      !testErrorAssicurazioni) {
      self.checkComponent({
        value: true,
      });
    } else {
      self.checkComponent({
        value: false,
      });
    }
  };

  var checkIfInsuranceIsPresent = function () {
    var codInsuranceSelected = self.model.leasingData.preventivo.assicurazioni.map(
      function (x) {
        return x.id;
      }
    );
    var isPresent = false;
    codInsuranceSelected.forEach(function (e) {
      self.supportModel.insurance.forEach(function (y) {
        if (e == y.id) {
          isPresent = true;
        }
      });
    });

    if (!isPresent) {
      populateDefaultInsurance();
    }
  };

  var checkInsuranceIsCompleted = function () {

    var numOfInsurance = self.model.leasingData.preventivo.assicurazioni.length;
    var control;
    if (numOfInsurance == 0) {
      control = false;
    } else {
      control = true;
    }


    for (var i = 0; i < numOfInsurance; i++) {
      control = control && !!self.model.leasingData.preventivo.assicurazioni[i].id;
    }

    return control;
  }

  var upgradeValueOfInsuranceSelected = function () {
    self.model.leasingData.preventivo.assicurazioni.forEach(function (element, index) {

      self.supportModel.insurance.forEach(function (insurance) {
        if (element.id == insurance.id) {
          Object.keys(element.polizze[0]).forEach(function (key) {
            if (key == 'premi') {
              element.polizze[0][key]['validations'] = insurance.polizze[0][key]['validations'];
              element.polizze[0][key]['permPremioPassivo'] = insurance.polizze[0][key]['permPremioPassivo'];
              element.polizze[0][key]['importoPremioPassivo'] = insurance.polizze[0][key]['importoPremioPassivo'];


            } else {
              element.polizze[0][key] = insurance.polizze[0][key];
            }
          })
          element.importoPolizzaCalcolato = insurance.importoPolizzaCalcolato
        }
      })
      var value = {
        value: element.polizze[0].premi.permPremioAttivo
      }
      self.handleInsuranceChange('permillari', value, index)

    })
  }
}